import React from 'react'
import Sidebar from '../../components/Sidebar/Sidebar'
import sidebarRoutes from '../../routes/sidebar'
import viewRoutes from '../../routes/view'
import {Redirect, Route, Switch} from 'react-router-dom'
import classNames from 'classnames'
import EnsureLoggedIn from './../../share/EnsureLoggedIn'
import BackToTopV2 from '../../views/helpers/BackToTopV2'

class Main extends React.Component {
    state = {
        isOpenSidebarMain: false,
        isOpenSidebarMobile: false,
        isCollapsed: true,
    }

    renderRoutes = (routes) => {
        return routes.map((route) => {
            /*
             * `to` nhận thêm dạng HÀM `(location) => to`. Lý do: `<Redirect to="/x?a=1">` dựng đích
             * chỉ từ chuỗi `to`, react-router KHÔNG nối `search` của URL nguồn — nên redirect một
             * link cũ có query là vứt sạch query đó. Dạng hàm cho phép route tự ghép.
             * `to` dạng chuỗi vẫn chạy như cũ.
             */
            if (route.redirect) {
                if (typeof route.to === 'function') {
                    return (
                        <Route
                            key={route.path}
                            exact={route.exact}
                            path={route.path}
                            render={({location}) => <Redirect to={route.to(location)}/>}
                        />
                    )
                }

                return <Redirect key={route.path} exact={route.exact} from={route.path} to={route.to}/>
            }

            if (route.component) {
                return <Route key={route.path} exact={route.exact} path={route.path} component={route.component}/>
            }

            if (route.items) {
                return this.renderRoutes(route.items)
            }

            return null
        })
    }

    toggleSidebarMain = () => {
        this.setState({
            isOpenSidebarMain: !this.state.isOpenSidebarMain
        })
    }

    toggleSidebarMobile = () => {
        this.setState({
            isOpenSidebarMobile: !this.state.isOpenSidebarMobile
        })
    }

    _toggleSidebarMenu = (e) => {
        e.preventDefault()
        this.setState({
            isCollapsed: !this.state.isCollapsed,
        })
    }

    render() {
        const {...rest} = this.props

        const mainClasses = classNames({
            'Main': true,
            'sidebar-xs': !this.state.isOpenSidebarMain,
            'sidebar-mobile-main': this.state.isOpenSidebarMobile,
        })

        return (
            <div className={mainClasses}>
                <div className='page-content'>
                    <EnsureLoggedIn>
                        <Sidebar {...rest} sidebar={sidebarRoutes}
                            isOpenSidebarMobile={this.state.isOpenSidebarMobile}
                            toggleSidebarMobile={this.toggleSidebarMobile} fixed  isCollapsed={this.state.isCollapsed} toggleSidebarMenu={this._toggleSidebarMenu}/>

                        <div className={classNames('content-wrapper', {'content-collapsed': this.state.isCollapsed, 'content-expand': !this.state.isCollapsed})}>
                            <div className='content'>
                                <Switch>
                                    {this.renderRoutes(sidebarRoutes)}
                                    {this.renderRoutes(viewRoutes)}
                                </Switch>
                            </div>
                        </div>
                    </EnsureLoggedIn>
                </div>
                <BackToTopV2 />
            </div>
        )
    }
}

export default Main
